import React from 'react';
import { Calendar } from 'lucide-react';
import { Input } from '../ui/input';
import { hoyEnMexico, fechaMenos } from '../../utils/dateFormat';

const PRESETS = [
  { id: 'today', label: 'Hoy' },
  { id: '7',     label: 'Últimos 7 días' },
  { id: '30',    label: 'Últimos 30 días' },
  { id: 'custom', label: 'Personalizado' },
];

// Los presets cuentan días de México, igual que el resto del tablero.
export function getPresetRange(presetId) {
  const end = hoyEnMexico();
  switch (presetId) {
    case 'today': return { start: end, end };
    case '7':  return { start: fechaMenos(end, { dias: 6 }), end };
    case '30': return { start: fechaMenos(end, { dias: 29 }), end };
    default: return null;
  }
}

const DateRangeFilter = ({ preset, start, end, onPresetChange, onStartChange, onEndChange }) => {
  const isCustom = preset === 'custom';
  return (
    <div className="flex flex-wrap items-end gap-4">
      <div className="flex items-center gap-2">
        <Calendar className="w-4 h-4 text-gray-500" />
        <span className="text-sm text-gray-600">Rango:</span>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        {PRESETS.map((p) => (
          <button
            key={p.id}
            type="button"
            onClick={() => onPresetChange(p.id)}
            className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
              preset === p.id
                ? 'bg-black text-white border border-black'
                : 'bg-white text-gray-600 border border-gray-200 hover:bg-gray-50 hover:text-gray-900'
            }`}
          >
            {p.label}
          </button>
        ))}
      </div>
      {isCustom && (
        <div className="flex flex-wrap items-center gap-2">
          <Input
            type="date"
            value={start}
            onChange={(e) => onStartChange(e.target.value)}
            className="bg-white border-gray-300 text-gray-900 w-40"
          />
          <span className="text-gray-500">a</span>
          <Input
            type="date"
            value={end}
            onChange={(e) => onEndChange(e.target.value)}
            className="bg-white border-gray-300 text-gray-900 w-40"
          />
        </div>
      )}
    </div>
  );
};

export default DateRangeFilter;
